import * as T from 'prop-types';

import CardWrapper from './card-wrapper';
import StepTitleIcon from './step-title-icon';

const StepCard = ({ isActive, isCompleted, isLoading, isLocked, title, ...props }) => (
  <CardWrapper isActive={isActive} disabled={isCompleted} {...props}>
    <StepTitleIcon
      isActive={isActive}
      isCompleted={isCompleted}
      isLoading={isLoading}
      isLocked={isLocked}
      title={title}
    />
  </CardWrapper>
);

StepCard.propTypes = {
  /**
   * Is the StepCard active?
   */
  isActive: T.bool,
  /**
   * Is the StepCard completed?
   */
  isCompleted: T.bool,
  /**
   * Is the StepCard loading?
   */
  isLoading: T.bool,
  /**
   * Is the StepCard locked?
   */
  isLocked: T.bool,
  /**
   * What is the StepCard title?
   */
  title: T.string.isRequired,
};

StepCard.defaultProps = {
  isActive: false,
  isCompleted: false,
  isLoading: false,
  isLocked: false,
};

export default StepCard;
